import React from 'react';
import { useForm } from 'react-hook-form';
import {
  Input,
  InputRadio,
  Button,
  FormControl,
  Flex,
  FormGroup,
  InputCheckBox,
  Box
} from '@itandi/itandi-bb-ui';
import { toast } from 'react-toastify';
import type {
  AdminSettingCompanySetting,
  CompanySetting
} from '~/models/CompanySetting';
import { useOpenHandler } from '~/hooks/useOpenHandler';
import { ConfirmModal } from '~/components/common/parts/modal/ConfirmModal';
import { updateCompanyInformation } from '~/utils/api/admin/CompanySetting';
import { isSuccess } from '~/utils/api/api_handler';

type Props = {
  companySetting: CompanySetting;
};
export const CompanySettingForm: React.FC<Props> = ({ companySetting }) => {
  const { isOpen, handleOpen, handleClose } = useOpenHandler();
  const { register, watch, getValues, setValue, handleSubmit } =
    useForm<AdminSettingCompanySetting>({ defaultValues: companySetting });
  const fromMarket = watch('fromMarket');
  const useIaStaffLogin = watch('useIaStaffLogin');
  const onlyAmaterasProperties = watch('onlyAmaterasProperties');
  const onClickSubmit = React.useCallback(() => {
    handleSubmit(() => {
      handleOpen();
    })();
  }, [handleSubmit, handleOpen]);
  const handleAccept = React.useCallback(async () => {
    const values = getValues();
    const response = await updateCompanyInformation(values);
    if (isSuccess(response)) {
      toast.success('保存しました');
      handleClose();
      return;
    }
    toast.error('保存に失敗しました');
  }, [getValues, handleClose]);
  return (
    <Box width={360}>
      <FormGroup variant="Vertical">
        <FormControl label="請求管理ロボ用請求先コード">
          <Input {...register('robotPaymentCode')} />
        </FormControl>
        <FormControl chip="必須" label="登録経路">
          <Flex gap={8}>
            <InputRadio
              checked={fromMarket === false}
              label="SaaS"
              name="fromMarket"
              onChange={(e): void => {
                setValue('fromMarket', e.currentTarget.value === 'true');
              }}
              value="false"
            />
            <InputRadio
              checked={fromMarket === true}
              label="マーケットプレイス"
              name="fromMarket"
              onChange={(e): void => {
                setValue('fromMarket', e.currentTarget.value === 'true');
              }}
              value="true"
            />
          </Flex>
        </FormControl>
        <FormControl chip="必須" label="物件情報の登録制御">
          <InputCheckBox
            checked={onlyAmaterasProperties}
            label="物件システムに登録されている物件のみ表示する"
            onChange={(e): void => {
              setValue('onlyAmaterasProperties', e.currentTarget.checked);
            }}
          />
        </FormControl>
        <FormControl chip="必須" label="イタンジアカウントの担当者の利用">
          <InputCheckBox
            checked={useIaStaffLogin}
            label="イタンジアカウントの担当者を利用する"
            onChange={(e): void => {
              setValue('useIaStaffLogin', e.currentTarget.checked);
            }}
          />
        </FormControl>
      </FormGroup>
      <Button marginTop={16} onClick={onClickSubmit} variant="primary">
        保存
      </Button>
      <ConfirmModal
        confirmType="save"
        handleAccept={handleAccept}
        handleCancel={handleClose}
        isOpen={isOpen}
      >
        保存してよろしいですか？
      </ConfirmModal>
    </Box>
  );
};
